// extracted by mini-css-extract-plugin
export default {"empty":"style_empty__Wh3jp","list":"style_list__lYWRz","consentText":"style_consentText__9esDQ"};